module.exports = __webpack_public_path__ + "img/gzh.1ddddb4f.jpeg";